<div class="referral">
    <h2 mat-dialog-title>{{ data.message }}</h2>
    
    <mat-dialog-actions class="py-2">
      <button mat-button type="button" class="btn btn-lg btn-primary continue-btn mx-2" (click)="onNegativeResponse()">Exit to Home Page</button>
      <button mat-button type="button" class="btn btn-lg btn-primary continue-btn" (click)="onSuccessResponse()">Proceed</button>
    </mat-dialog-actions>
    </div>